import React from 'react';
import { useTranslation } from 'react-i18next';
import { LegalLayout, LegalSection } from '@/components/LegalLayout';

// Operator identification not yet available: shown as "to be completed",
// never filled with invented details.
const Placeholder = ({ labelKey, t }) => (
  <span className="inline-block rounded bg-slate-100 border border-slate-200 text-slate-500 text-xs px-2 py-0.5 align-middle" data-testid="legal-placeholder">
    [{t('legal.placeholderToComplete', { label: t(labelKey) })}]
  </span>
);

export default function LegalPage() {
  const { t } = useTranslation();
  return (
    <LegalLayout ns="legal" seo="legal" testId="legal-page">
      <LegalSection title={t('legal.section1Title')}>
        <p><strong>{t('legal.labelSite')}</strong> ridalo.co</p>
        <p><strong>{t('legal.labelCompanyName')}</strong> <Placeholder labelKey="legal.placeholderCompanyName" t={t} /></p>
        <p><strong>{t('legal.labelLegalForm')}</strong> <Placeholder labelKey="legal.placeholderLegalForm" t={t} /></p>
        <p><strong>{t('legal.labelAddress')}</strong> <Placeholder labelKey="legal.placeholderAddress" t={t} /></p>
        <p><strong>{t('legal.labelRegistration')}</strong> <Placeholder labelKey="legal.placeholderRegistration" t={t} /></p>
        <p><strong>{t('legal.labelEmail')}</strong> admin@ridalo.co</p>
      </LegalSection>
      <LegalSection title={t('legal.section2Title')}>
        <p><Placeholder labelKey="legal.placeholderPublisher" t={t} /></p>
      </LegalSection>
      <LegalSection title={t('legal.section3Title')}>
        <p><Placeholder labelKey="legal.placeholderHost" t={t} /></p>
      </LegalSection>
    </LegalLayout>
  );
}
